import { cn } from '@/utils/utils'

interface PageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const PageContainer = ({ children, className, ...props }: PageContainerProps) => (
  <div className={cn('p-6 max-w-6xl mx-auto w-full', className)} {...props}>
    {children}
  </div>
)
